// Silencia los toasts de éxito/info/warning globalmente.
// Solo se muestran los toast.error (mensajes críticos).
// El feedback positivo debe darse directamente en la UI (badges, listas, etc.).
import { toast } from "sonner";

const noop = () => "";
toast.success = noop;
toast.info = noop;
toast.warning = noop;
toast.message = noop;
toast.loading = noop;
